module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/messenger-badge-8e4dbe0509f2a60ea3418cf7b7ada84c.svg";